import React from 'react'
import './PageHeader.css'

interface PageHeaderProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => {
  return (
    <div className="pageHeader">
      <div className="pageHeader__content">
        <h1 className="pageHeader__title">{title}</h1>
        {subtitle && <p className="pageHeader__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="pageHeader__action">{action}</div>}
    </div>
  )
}
